import Vue from "vue";
import Vuex from "vuex";
import AppFormSponsorship from "./AppFormSponsorship.vue";
import AppFormAnnualTax from "./AppFormAnnualTax.vue";
import AppFormSponsorship177 from "./AppFormSponsorship177.vue";

import StoreFormSponsorship from "./redux/state.json";
import MutationsFormSponsorship from "./redux/mutations";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: StoreFormSponsorship,
  mutations: MutationsFormSponsorship
});

new Vue({
  el: "#app",
  store,
  render: h => h(AppFormSponsorship)
});

new Vue({
  el: "#app2",
  store,
  render: h => h(AppFormAnnualTax)
});

new Vue({
  el: "#app3",
  store,
  render: h => h(AppFormSponsorship177)
});
